"use strict";

module.exports = /* @ngInject */ function(
  openFinApi,
  eikonAttributeRepository,
  openFinWindowUtils,
  eikonErrorCodes,
  $log,
  $q
) {
  var that = this;
  var assetAlias = "eikonLightInstaller";
  var assetTarget = "setup.exe";

  that.maybeInstallOrUpgrade = function(sxsPort) {
    return eikonAttributeRepository
      .getEikonLightAttributes(sxsPort)
      .then(function(eikonLightAttributes) {
        var version = eikonLightAttributes.eikonLightVersion;
        var installerAsset = createInstallerAsset(
          eikonLightAttributes.installerUrl,
          version
        );
        return openFinApi.getFin().then(function(fin) {
          return isConfiguredVersionInstalled(fin, version).then(function(
            isConfiguredVersionInstalled
          ) {
            if (!isConfiguredVersionInstalled) {
              return downloadAsset(fin, installerAsset).then(function() {
                return launchInstaller(fin, version);
              });
            }
          });
        });
      });
  };

  that.forceReInstall = function() {
    return eikonAttributeRepository
      .getEikonLightAttributes()
      .then(function(eikonLightAttributes) {
        var version = eikonLightAttributes.eikonLightVersion;
        $log.info("Forcing re-install of Eikon version " + version);
        return openFinApi.getFin().then(function(fin) {
          return launchInstaller(fin, version);
        });
      });
  };

  var isConfiguredVersionInstalled = function(fin, version) {
    return $q(function(resolve, reject) {
      fin.desktop.System.getAppAssetInfo(
        { alias: assetAlias },
        function(assetInfo) {
          var installedVersion = assetInfo.version;
          $log.info(
            "Installed version of Eikon is " +
              installedVersion +
              ", current configured version is " +
              version
          );
          resolve(installedVersion && installedVersion === version);
        },
        function(reason, err) {
          $log.error("App Asset Info fetch failed: ", err);
          $log.warn("In context of checking installed Eikon version");
          $log.warn(
            "facing there is no way to tell if it failed to check the version because Eikon hasn't been downloaded to the machine yet or because some real error occurred (it fails if asset alias hasn't been downloaded yet the same way it fails when any other error occurred)"
          );
          $log.warn(
            "we decided to assume all errors are due to Eikon not being downloaded yet"
          );
          $log.warn(
            "to achieve downloading Eikon on client's machine for the first time"
          );
          $log.warn(
            "accepting that it causes silent failure if it was a real issue"
          );
          resolve(false);
        }
      );
    });
  };

  var createInstallerAsset = function(url, version) {
    return {
      src: url,
      alias: assetAlias,
      version: version,
      target: assetTarget,
      args: "--silent --noshortcut --product=redi --forceInstall"
    };
  };

  var launchInstaller = function(fin, version) {
    return $q(function(resolve, reject) {
      fin.desktop.System.launchExternalProcess(
        {
          version: version,
          target: assetTarget,
          alias: assetAlias,
          listener: function(installerResult) {
            if (installerResult.exitCode === 0) {
              $log.info("Successfully installed Eikon");
              resolve();
            } else {
              $log.error("Error installing Eikon: ", installerResult.exitCode);
              reject(
                new Error(
                  eikonErrorCodes[installerResult.exitCode] ||
                    "Failed to install Eikon with an unexpected exit code " +
                      installerResult.exitCode
                )
              );
            }
          }
        },
        function() {
          $log.info("Successfully called Eikon installer");
        },
        function(reason, error) {
          $log.error("Error installing Eikon: ", error);
          reject(new Error(reason));
        }
      );
    });
  };

  var downloadAsset = function(fin, installerAsset) {
    $log.info("downloadingAsset for Eikon installer");
    return $q(function(resolve, reject) {
      fin.desktop.System.downloadAsset(
        installerAsset,
        function(progress) {
          var downloadedPercent = Math.floor(
            (progress.downloadedBytes / progress.totalBytes) * 100
          );
          if (downloadedPercent % 5 === 0) {
            $log.info("Downloaded " + downloadedPercent + "%");
          }
        },
        function() {
          $log.info("Download Complete");
          resolve();
        },
        function(reason, err) {
          $log.error("Eikon Download Failed error: ", err);
          reject(new Error(reason));
        }
      );
    });
  };
};



// WEBPACK FOOTER //
// ./app/infrastructure/eikonLightInstaller.js